import {
    type GetProfileUpdateRequestResponseType,
    type GetProfileUpdateRequestRequestType
} from "./type";
import {
    request
} from "../request";

const getProfileUpdateRequest = async (
    params: GetProfileUpdateRequestRequestType
): Promise<GetProfileUpdateRequestResponseType> => {
    return await request<GetProfileUpdateRequestResponseType>(
        `/request/getProfileUpdateRequest?requestID=${params.requestID}`,
        {
            method: "GET"
        }
    );
};
export default getProfileUpdateRequest;
